import { OwcThemeProvider } from '@one/react/providers';
import { PredefinedTheme } from '@one/web-components';
import 'core/theme/theme.config';
import React, { useState } from 'react';
import { createGlobalStyle } from 'styled-components';

/**
 * Special provider for global styles and theming
 */
export const GlobalStyleProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [theme] = useState<PredefinedTheme>('regular_navify_light');

  return (
    <OwcThemeProvider baseTheme={theme}>
      <GlobalStyle />
      {children}
    </OwcThemeProvider>
  );
};

/**
 * Inject global styles with this initializer component
 */
export const GlobalStyle = createGlobalStyle`
  /**
   * Global custom styles
   */

  body {
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    margin: 0;
    font-family:  var(--one-typography-font-family);
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow: hidden;

    #root {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }

  * {
    box-sizing: border-box;
    /* color : var(--one-color-black-800); */
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }

  a {
    color: inherit; /* blue colors for links too */
    text-decoration: inherit; /* no underline */
  }

  /**
   * OWC Customization
   */

  // Design tokens fine-tuned definitions
  :root {
    // Due to an issue in the design tokens, typography vs other components do not
    // share the same font family (Roche Sans for typography vs Roboto for buttons,
    // for example). Let's force a font family redeclaration.
    // https://code.roche.com/onedesign/design-tokens/-/issues/85
    // !important has to be added due to OwcThemeProvider injecting tokens always last.
    --one-text-font-family-default: var(--one-text-font-family-roche-sans) !important;
  }
  // Scrollbar fine-tuned style
  ::-webkit-scrollbar {
      width: 18px;
      height: 18px;
    }
    ::-webkit-scrollbar-track {
      background: transparent;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 18px;
      -webkit-border-radius: 18px;
      border: 6px solid rgba(0, 0, 0, 0);
      background-clip: padding-box,
    }
    ::-webkit-scrollbar-thumb:hover {
      border-radius: 18px;
      -webkit-border-radius: 18px;
      border: 6px solid rgba(0, 0, 0, 0);
      background-clip: padding-box;
    }
    ::-webkit-scrollbar-button {
      width: 0;
      height: 0;
      display: none;
    }
    ::-webkit-scrollbar-corner {
      background-color: transparent;
    }
`;
